import axios from 'axios';
import React, { useEffect, useState } from 'react';
import DefaultLoader from '../../../components/loader/DefaultLoader';
import { flatObject } from '../../../utils/flat';
import {useCookies} from 'react-cookie';
import RecentGameModal from '../../../components/video/RecentGameModal';
import dateSetting from '../../../utils/dateSetting';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

function RecentGameList({profile}) {
    const [cookies] = useCookies(['hiball_token']);
    let [recentGame, setRecentGame] = useState([]);
    let [loading, setLoading] = useState(false);
    let {type} = profile;
    const { t } = useTranslation();

    let useLang = localStorage.getItem('language');

    useEffect(() => {
        let playerId = profile['playerId'];
        let params = {
            seasons: dateSetting['season'], 
            gameTypeCode: 4201, groupingColumn: 'gamePlayer', limitEnd : 10,
            authToken:JSON.stringify(cookies['hiball_token'])
        };

        if(type === 'batter') {
            params['recordType'] = 'digestBattingRecord';
            params['recordName'] = 'seasonRecord';
            params['batterIds'] = playerId
        } else {
            params['recordType'] = 'digestPitchingRecord';
            params['recordName'] = 'selectSeasonRecord';
            params['pitcherIds'] = playerId
        }

        axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params
        }).then((result) => {
            let flatResult = result['data']['result'].map((item) => {
                let gameDay = new Date(item['gameDay']);
                let month = gameDay.getMonth();
                let day = gameDay.getDate();
                let innerData = flatObject(item);
                let dataString = playerTypeRecordCalc(type, innerData);
                innerData['statString'] = dataString;
                innerData['dateString'] = (month+1)+'.'+day;

                return innerData;
            });

            let sortData = _.sortBy(flatResult, (item) => item['gameDay']);
            setRecentGame(...recentGame, sortData);
            setLoading(true);
        })
    }, []);

    if(!loading) {
        return <div style={{height: '300px'}}><DefaultLoader /></div>
    }

    if(recentGame.length === 0) {
        return <div style={{textAlign:'center', width:'100%', height:'300px', 
        display: 'flex',justifyContent: 'center', alignItems: 'center'}}>
            No Data
        </div>
    }

    return (
        <>
            <table>
                <thead>
                    <tr>
                        <th>{t('date')}</th>
                        <th>{t('team')}</th>
                        <th>{t('gameLog')}</th>
                        <th>{t('video')}</th>
                    </tr>
                </thead>
                <tbody>
                    {recentGame.map((item) => (
                        <tr key={item['gameInfoId']}>
                            <td>{item['dateString']}</td>
                            <td>{type === 'batter' 
                                    ? (useLang === "en" ? item['englishPitcherTeamName'] : item['pitcherTeamName'] )
                                    : (useLang === "en" ? item['englishBatterTeamName'] : item['batterTeamName'])}
                            </td>
                            <td>{item['statString']}</td>
                            <td>
                                <RecentGameModal 
                                    gameInfoId={item['gameInfoId']} 
                                    type={profile.type} 
                                    playerId={profile.playerId}
                                    teamId={type === 'batter' ? item['batterTeamId'] : item['pitcherTeamId']}
                                    tpa={item['basicStat_tpa']}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    )
}

function playerTypeRecordCalc(type, innerData) {
    let useLang = localStorage.getItem('language');
    let dataString = "";
    if(type === 'batter') {
        let slgData = innerData['basicStat_b2b']+innerData['basicStat_b3b']+innerData['basicStat_hr'];
        // let totalBb = innerData['basicStat_bb'] + innerData['basicStat_ibb'];

        dataString += `${innerData['basicStat_ab']}` + (useLang === 'en' ? "AB" : "타수") + " ";
        dataString += `${innerData['basicStat_hit']}` + (useLang === 'en' ? "H" : "안타");
        // dataString += (totalBb*1 !== 0 ? ' ('+totalBb+(useLang === 'en' ? "BB/HBP" : "사사구")+')' : '')
        if(slgData !== 0) {
            dataString += '\n(';
            dataString += (innerData['basicStat_b2b']*1 !== 0 ? innerData['basicStat_b2b']+" "+(useLang === 'en' ? "Double" : "2루타")+' ' : '' );
            dataString += (innerData['basicStat_b3b']*1 !== 0 ? innerData['basicStat_b3b']+" "+(useLang === 'en' ? "Triple" : "3루타")+' ' : '' );
            dataString += (innerData['basicStat_hr']*1 !==0 ? innerData['basicStat_hr']+" "+(useLang === 'en' ? "Homerun" : "홈런") : '' );
            dataString += ')';
        } else {
            dataString += '\n';
        }
        
    } else {
        dataString += `${innerData['ip']}`+ (useLang === 'en' ? "IP" : "이닝") + " ";
        dataString += `${innerData['basicStat_er']}` + (useLang === 'en' ? "ER" : "자책") + "\n";
        // dataString += `${innerData['basicStat_tpa']}` + (useLang === 'en' ? "TBF" : "타자") + "\n";
        dataString += `${innerData['basicStat_hit']}` + (useLang === 'en' ? "H" : "안타") + " ";
        dataString += `${innerData['basicStat_so']}` + (useLang === 'en' ? "SO" : "삼진") + " ";
        dataString += `${innerData['basicStat_bb']+innerData['basicStat_ibb']}` + (useLang === 'en' ? "BB" : "볼넷" );
    }

    return dataString;
}

export default RecentGameList;